import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Filters from './components/inputs/'
import Tables from './components/tables';
import TablesStock from './components/tablesStock';
import ChartsLiner from './components/charts/index';

let useStyles = makeStyles((theme) => ({
    root: {
        padding: '20px',
        [theme.breakpoints.down("700")]: {
            width:'100%',
            padding: '5px',
        },
    },
    grid: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: 20,
        [theme.breakpoints.down("1100")]: {
          flexDirection:'column'
        },
    }
}))


export default function Index() {

    let classes = useStyles();

    const [stock, setStock] = useState({

        // "NCI-OANMMSF-00": {
        //     "keys": [
        //         {
        //             "id": "Attachment",
        //             "label": "پیوست",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "trade_date",
        //             "label": "تاریخ عرضه",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "commodity_id",
        //             "label": "نام کالا",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "offer_symbol",
        //             "label": "نماد",
        //             "minWidth": 120,
        //             "align": "left",
        //             "check": false
        //         },
        //         {
        //             "id": "manufacturer_id",
        //             "label": "تولید کننده",
        //             "minWidth": 120,
        //             "align": "right",
        //             "check": false
        //         },
        //         {
        //             "id": "final_weighted_average_price",
        //             "label": "عرضه کننده",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "offer_volume",
        //             "label": "حجم کالای قابل عرضه",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": true
        //         },
        //         {
        //             "id": "contract_type_id",
        //             "label": "نوع قرارداد",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "offer_base_price",
        //             "label": "قیمت پایه",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "supplier_id",
        //             "label": "مکان تحویل",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "currency_id",
        //             "label": "نوع ارز",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "measurement_unit_id",
        //             "label": "واحد",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         }
        //     ],
        //     "active": true,
        //     "data": {
        //         "id": "715916_1402/09/05",
        //         "body": {
        //             "buy_method": "عادی",
        //             "commodity_id": 15212,
        //             "commodity_detail": {
        //                 "symbol": "OANMMSF",
        //                 "parentId": 23,
        //                 "description": "سولفور مولیبدن",
        //                 "persianName": "سولفور مولیبدن",
        //                 "id": 15212
        //             },
        //             "contract_type_id": 1,
        //             "contract_type_detail": {
        //                 "description": "نقدی",
        //                 "persianName": "نقدی",
        //                 "id": 1
        //             },
        //             "currency_id": 1,
        //             "currency_detail": {
        //                 "description": "ریال",
        //                 "persianName": "ریال",
        //                 "id": 1
        //             },
        //             "demand_volume": 10,
        //             "due_date": "",
        //             "final_weighted_average_price": 5314000,
        //             "manufacturer_id": 10,
        //             "manufacturer_detail": {
        //                 "symbol": "NCI",
        //                 "description": "ملی صنایع مس ایران",
        //                 "persianName": "ملی صنایع مس ایران",
        //                 "id": 10
        //             },
        //             "maximum_price": 5314000,
        //             "measurement_unit_id": 1,
        //             "measurement_unit_detail": {
        //                 "description": "کیلوگرم",
        //                 "persianName": "کیلوگرم",
        //                 "id": 1
        //             },
        //             "minimum_price": 5314000,
        //             "offer_base_price": 5314000,
        //             "offer_id": 715916,
        //             "offer_mode": "عمده",
        //             "offer_symbol": "NCI-OANMMSF-00",
        //             "offer_type": "عرضه داخلی",
        //             "offer_volume": 10,
        //             "seller_broker_id": 67,
        //             "seller_broker_detail": {
        //                 "nationalId": "10860569396",
        //                 "spotId": 67,
        //                 "derivativesId": null,
        //                 "description": "ارگ هومن",
        //                 "persianName": "ارگ هومن",
        //                 "id": 67
        //             },
        //             "supplier_id": 4,
        //             "supplier_detail": {
        //                 "customerId": 4,
        //                 "nationalCode": "10100582059",
        //                 "description": "ملی صنایع مس ایران",
        //                 "persianName": "ملی صنایع مس ایران",
        //                 "id": 4
        //             },
        //             "trade_date": "1402/09/05",
        //             "trade_value": 53140000,
        //             "trade_volume": 10,
        //             "id_trade": 715916
        //         }
        //     }
        // },
        // "MPC-DEGB-00": {
        //     "keys": [
        //         {
        //             "id": "Attachment",
        //             "label": "پیوست",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "trade_date",
        //             "label": "تاریخ عرضه",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "commodity_id",
        //             "label": "نام کالا",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "offer_symbol",
        //             "label": "نماد",
        //             "minWidth": 120,
        //             "align": "left",
        //             "check": false
        //         },
        //         {
        //             "id": "manufacturer_id",
        //             "label": "تولید کننده",
        //             "minWidth": 120,
        //             "align": "right",
        //             "check": false
        //         },
        //         {
        //             "id": "final_weighted_average_price",
        //             "label": "عرضه کننده",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": true
        //         },
        //         {
        //             "id": "offer_volume",
        //             "label": "حجم کالای قابل عرضه",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": true
        //         },
        //         {
        //             "id": "contract_type_id",
        //             "label": "نوع قرارداد",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "offer_base_price",
        //             "label": "قیمت پایه",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": true
        //         },
        //         {
        //             "id": "supplier_id",
        //             "label": "مکان تحویل",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "currency_id",
        //             "label": "نوع ارز",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         },
        //         {
        //             "id": "measurement_unit_id",
        //             "label": "واحد",
        //             "minWidth": 120,
        //             "align": "center",
        //             "check": false
        //         }
        //     ],
        //     "active": true,
        //     "data": {
        //         "id": "MPC-DEGB-00_1402/08/17",
        //         "body": {
        //             "buy_method": "عادی",
        //             "commodity_id": 1378,
        //             "commodity_detail": {
        //                 "symbol": "DEGB",
        //                 "parentId": 98,
        //                 "description": "دی اتیلن گلایکول",
        //                 "persianName": "دی اتیلن گلایکول",
        //                 "id": 1378
        //             },
        //             "contract_type_id": 1,
        //             "contract_type_detail": {
        //                 "description": "نقدی",
        //                 "persianName": "نقدی",
        //                 "id": 1
        //             },
        //             "currency_id": 1,
        //             "currency_detail": {
        //                 "description": "ریال",
        //                 "persianName": "ریال",
        //                 "id": 1
        //             },
        //             "demand_volume": 408,
        //             "due_date": "",
        //             "final_weighted_average_price": 218182,
        //             "manufacturer_id": 108,
        //             "manufacturer_detail": {
        //                 "symbol": "MPC",
        //                 "description": "پتروشیمی مارون",
        //                 "persianName": "پتروشیمی مارون",
        //                 "id": 108
        //             },
        //             "maximum_price": 222222,
        //             "measurement_unit_id": 1,
        //             "measurement_unit_detail": {
        //                 "description": "کیلوگرم",
        //                 "persianName": "کیلوگرم",
        //                 "id": 1
        //             },
        //             "minimum_price": 213889,
        //             "offer_base_price": 206904,
        //             "offer_id": 708752,
        //             "offer_mode": "عمده",
        //             "offer_symbol": "MPC-DEGB-00",
        //             "offer_type": "عرضه داخلی",
        //             "offer_volume": 216,
        //             "seller_broker_id": 39,
        //             "seller_broker_detail": {
        //                 "nationalId": "10101388534",
        //                 "spotId": 39,
        //                 "derivativesId": 48,
        //                 "description": "آرمون بورس",
        //                 "persianName": "آرمون بورس",
        //                 "id": 39
        //             },
        //             "supplier_id": 291,
        //             "supplier_detail": {
        //                 "customerId": 10886,
        //                 "nationalCode": "10860727671",
        //                 "description": "پتروشیمی مارون",
        //                 "persianName": "پتروشیمی مارون",
        //                 "id": 291
        //             },
        //             "trade_date": "1402/08/17",
        //             "trade_value": 47127384,
        //             "trade_volume": 216,
        //             "id_trade": 708752
        //         }
        //     }
        // }

    });
    
    const [state, setState] = useState({
        commodity_id: null,
        main_category: null,
        category: null,
        sub_category: null,
        date_from: null,
        date_to: null,
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [flegApi, setFlagApi] = useState(false);


    return (
        <>
            <div className={classes['root']}>
                <Filters
                    state={state}
                    setState={setState}
                    setFlagApi={setFlagApi}
                />
                <Tables
                    page={page}
                    state={state}
                    flegApi={flegApi}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    stock={stock}
                    setStock={setStock}
                />
                <div className={classes['grid']}>
                <TablesStock
                    data={state}
                    stock={stock}
                    setStock={setStock}
                />
                <ChartsLiner />
                </div>
            </div>
        </>

    )
}
